<template>
  <div>
    <b-row>
      <b-col md="4">
        <v-select
          v-model="activeBranch"
          label="nameEn"
          placeholder="Select Branch"
          :options="branches"
          :loading="fetchingDetails"
        />
      </b-col>
      <b-col
        md="2"
        class="mb-2"
      >
        <b-button
          variant="primary"
          :disabled="fetchingDetails"
          @click="fetch"
        >
          Refresh Branches
        </b-button>
      </b-col>
      <b-col
        v-if="activeBranch"
        md="12"
      >
        <b-card>
          <CreateFixedLocation
            v-if="displayFixedLocationForm"
            :fixed-location="fixedLocationData"
            :branch="activeBranch"
            @close="() => {
              fixedLocationData = undefined
              displayFixedLocationForm = false
            }"
            @done="onFixedLocationSaved"
          />
          <div class="d-flex justify-content-between align-items-center">
            <h3>Fixed Locations for {{ activeBranch.name.en }}</h3>
            <b-button
              variant="primary"
              @click="createNewFixedLocationHandler"
            >
              Create new fixed location
            </b-button>
          </div>
          <div v-if="!activeBranch.fixedLocations">
            No fixed locations for this branch yet
          </div>
          <template v-else>
            <div
              v-for="(f, ix) in activeBranch.fixedLocations"
              :key="f.address + ix"
              class="d-flex align-items-center my-1"
            >
              <span class="mr-1">Address: {{ f.address }} &#8226;</span>
              <span class="mr-1">Latitude: {{ f.lat }} &#8226;</span>
              <span class="mr-1">Longitude: {{ f.lon }}</span>
              <b-button
                class="ml-auto"
                size="sm"
                variant="primary"
                @click="viewFixedLocation(f)"
              >
                View / Edit
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import CreateFixedLocation from './CreateFixedLocation.vue'

export default {
  components: {
    vSelect, BRow, BCol, BCard, BButton, CreateFixedLocation,
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const fetchingDetails = ref(false)
    const details = ref(undefined)
    const activeBranch = ref()
    const branches = ref([])
    const displayFixedLocationForm = ref(false)
    const fixedLocationData = ref()
    const fetch = async () => {
      fetchingDetails.value = true
      const res = await ctx.root.$store.dispatch(
        'business/getBusinessDetails',
        {
          businessId,
        },
      )
      const { data } = res.data.data
      branches.value = data.branches.map(b => ({
        ...b,
        // Assign ids to enable editing
        fixedLocations: b.fixedLocations ? b.fixedLocations.map(f => ({ ...f, id: Math.random().toString() })) : undefined,
        nameEn: b.name.en,
        nameAr: b.name.ar,
      }))
      if (activeBranch.value) {
        const currViewedBranch = branches.value.find(b => b.id === activeBranch.value.id)
        // Refresh Data for active branch
        activeBranch.value = currViewedBranch
      } else {
        const firstBranch = branches.value[0]
        activeBranch.value = firstBranch
      }
      details.value = data
      fetchingDetails.value = false
    }
    fetch()

    const viewFixedLocation = f => {
      displayFixedLocationForm.value = false
      fixedLocationData.value = f
      //   Timeout to trigger form re render
      setTimeout(() => {
        displayFixedLocationForm.value = true
      }, 200)
    }

    const onFixedLocationSaved = () => {
      displayFixedLocationForm.value = false
      fetch()
    }

    const createNewFixedLocationHandler = () => {
      displayFixedLocationForm.value = false
      fixedLocationData.value = undefined
      setTimeout(() => {
        displayFixedLocationForm.value = true
      }, 100)
    }

    return {
      fetch,
      activeBranch,
      fetchingDetails,
      details,
      branches,
      displayFixedLocationForm,
      viewFixedLocation,
      createNewFixedLocationHandler,
      fixedLocationData,
      onFixedLocationSaved,
    }
  },

}
</script>
